
import axios from 'axios';

import {message} from 'ant-design-vue'
message.config({
  maxCount : 1 ,
  duration : 1
});
const service = axios.create({
    baseURL : 'http://47.95.36.14/jutong/web/',
    // baseURL : 'http://www.tong122.com/jutong/web/',
    timeout: 20000, // 请求超时时间
    withCredentials: true
});

service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.data.corpId= "1269177301640257537";
    return config;
  }, function (error) {
    // 对请求错误做些什么
    message.error('服务器异常')
    return Promise.reject(error);
  });

service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if(response.data.code == 0){
      return response.data.data
    }
    if(response.data.code ==  300){
      message.error('服务器异常')
      return response.data.data
    }
    return response;
  }, function (error) {
    message.error('服务器维护中...')
    return Promise.reject(error);
  });

export default service;

